import { BaseIcon } from '../base-icon'
import { IconProps } from '../icons.props'

export const LinkIcon = ({ color, size = 24, ...props }: IconProps<24>) => (
  <BaseIcon {...props} color={color} height={size} width={size}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M15.72 18.47a.75.75 0 1 0 1.06 1.06l7-7a.75.75 0 0 0 0-1.06l-7-7a.75.75 0 1 0-1.06 1.06l5.72 5.72H.75a.75.75 0 0 0 0 1.5h20.69l-5.72 5.72Z"
      clipRule="evenodd"
    />
  </BaseIcon>
)
